// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordResetForm_root__1JGRv","password":"PasswordResetForm_password__Wi36r"};